"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IntegrationTab = exports.InstallationTab = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _PanelItems = require("../PanelItems");

var _Message = require("../../../ui-components/Message");

var _AccordionPanel = _interopRequireDefault(require("../../../panel/AccordionPanel"));

var _TicketSyncStatus = _interopRequireDefault(require("./TicketSyncStatus"));

var _IntegrationPanelItems = require("../integration-panel/IntegrationPanelItems");

var _FederatedSearchIntegrationPanel = require("./FederatedSearchIntegrationPanel");

var _InstallationPanel = require("./InstallationPanel");

var _constants = require("@insided/shared/constants");

var IntegrationTab = function IntegrationTab(_ref) {
  var activePanel = _ref.activePanel,
      isInstalled = _ref.isInstalled,
      hasUnsavedChanges = _ref.hasUnsavedChanges,
      showUnsavedChangesModal = _ref.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref.displayUnsavedChangedModal,
      _closeModal = _ref.closeModal,
      _resetChanges = _ref.resetChanges,
      storedState = _ref.storedState,
      isTicketCreationEnabled = _ref.isTicketCreationEnabled,
      saveTicketCreationSetting = _ref.saveTicketCreationSetting,
      resetTicketCreationSetting = _ref.resetTicketCreationSetting,
      onTicketCreationSettingChanged = _ref.onTicketCreationSettingChanged,
      showTicketCreationActionButtons = _ref.showTicketCreationActionButtons,
      isSyncTicketDataActive = _ref.isSyncTicketDataActive,
      showSyncTicketDataActionButtons = _ref.showSyncTicketDataActionButtons,
      saveSyncTicketDataSetting = _ref.saveSyncTicketDataSetting,
      resetSyncTicketDataSetting = _ref.resetSyncTicketDataSetting,
      onSyncTicketDataSettingChanged = _ref.onSyncTicketDataSettingChanged,
      isFederatedSearchActive = _ref.isFederatedSearchActive,
      language = _ref.language,
      categories = _ref.categories,
      saveFederatedSearchSetting = _ref.saveFederatedSearchSetting,
      resetFederatedSearchSetting = _ref.resetFederatedSearchSetting,
      onFederatedSearchSettingChanged = _ref.onFederatedSearchSettingChanged,
      showFederatedSearchActionButtons = _ref.showFederatedSearchActionButtons,
      onLanguageChanged = _ref.onLanguageChanged,
      onCategoriesChanged = _ref.onCategoriesChanged,
      onLanguageInputClicked = _ref.onLanguageInputClicked,
      onCategoriesInputClicked = _ref.onCategoriesInputClicked,
      onClickPanelCallback = _ref.onClickPanelCallback,
      isTicketEscalationEnabled = _ref.isTicketEscalationEnabled,
      isFederatedSearchEnabled = _ref.isFederatedSearchEnabled,
      isSelfServiceDashboardEnabled = _ref.isSelfServiceDashboardEnabled,
      federatedSearchSyncInProgress = _ref.federatedSearchSyncInProgress,
      isSavingCaseCreationSetting = _ref.isSavingCaseCreationSetting,
      isSavingFederatedSearchSetting = _ref.isSavingFederatedSearchSetting,
      isSavingTicketSyncSetting = _ref.isSavingTicketSyncSetting;
  var TicketCreationIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Create Zendesk tickets from community posts',
    isInstalled: isInstalled,
    imageFromName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    imageToName: 'zendesk-support-s',
    isSettingEnabled: isTicketCreationEnabled,
    onSettingChanged: onTicketCreationSettingChanged,
    onSave: saveTicketCreationSetting,
    onCancel: resetTicketCreationSetting,
    showActionButtons: showTicketCreationActionButtons,
    toggleLabel: 'Enable moderators to create Zendesk tickets',
    communityArticleLink: 'https://community.insided.com/integrations-124/escalate-a-community-post-to-zendesk-a-brief-tutorial-1454',
    description: (0, _preact.h)("div", null, "Create a Zendesk ticket from any user-generated content (questions, conversations, ideas, replies) via Control."),
    additionalHelpText: (0, _preact.h)("span", null, "Open a topic from the ", (0, _preact.h)("a", {
      className: "overview-page-link",
      target: "_blank",
      rel: "noreferrer",
      href: (0, _absoluteUrlRuntime.resolveUrl)("/overview")
    }, "content overview"), " and click the Zendesk logo next to any user-generated content to create a ticket."),
    storedIsSettingEnabled: storedState.isTicketCreationEnabled,
    hasUnsavedChanges: hasUnsavedChanges,
    customClass: 'qa-ticket-creation',
    onClickPanel: onClickPanelCallback,
    isLoading: isSavingCaseCreationSetting
  });
  var SelfServiceIntegrationPanel = (0, _IntegrationPanelItems.getIntegrationPanel)({
    title: 'Measure your self-service score',
    isInstalled: isInstalled,
    imageFromName: 'zendesk-support-s',
    imageToName: _constants.PLATFORM_INTEGRATION_LOGO_S_FILENAME,
    isSettingEnabled: isSyncTicketDataActive,
    onSettingChanged: onSyncTicketDataSettingChanged,
    onSave: saveSyncTicketDataSetting,
    onCancel: resetSyncTicketDataSetting,
    showActionButtons: showSyncTicketDataActionButtons,
    toggleLabel: 'Automatically import Zendesk ticket data',
    communityArticleLink: 'https://community.insided.com/dashboards-94/how-to-configure-the-self-service-dashboard-3596',
    description: (0, _preact.h)("div", null, "Calculate your self-service score in ", (0, _preact.h)("a", {
      className: "overview-page-link",
      target: "blank",
      href: (0, _absoluteUrlRuntime.resolveUrl)("/analyticsV2/dashboard/self-service")
    }, "Self-service dashboard"), " by measuring the ratio of unique users who create tickets against the unique users who viewed help content on ", _constants.PLATFORM_BRAND_NAME, "."),
    additionalHelpText: (0, _preact.h)("span", null, "Check out the ", (0, _preact.h)("a", {
      className: "overview-page-link",
      target: "blank",
      href: (0, _absoluteUrlRuntime.resolveUrl)("/analyticsV2/dashboard/self-service")
    }, "Self-service dashboard"), " to see your self-service score and customer support and self-service trends."),
    integrationStatus: (0, _preact.h)(_TicketSyncStatus.default, {
      isSyncTicketDataActive: storedState.isSyncTicketDataActive
    }),
    storedIsSettingEnabled: storedState.isSyncTicketDataActive,
    hasUnsavedChanges: hasUnsavedChanges,
    customClass: 'qa-self-service',
    onClickPanel: onClickPanelCallback,
    isLoading: isSavingTicketSyncSetting
  });
  var FederatedSearchIntegrationPanel = (0, _FederatedSearchIntegrationPanel.getFederatedSearchIntegrationPanel)({
    isInstalled: isInstalled,
    isSettingEnabled: isFederatedSearchActive,
    onSave: saveFederatedSearchSetting,
    onCancel: resetFederatedSearchSetting,
    onSettingChanged: onFederatedSearchSettingChanged,
    showActionButtons: showFederatedSearchActionButtons,
    hasUnsavedChanges: hasUnsavedChanges,
    onClickPanelCallback: onClickPanelCallback,
    language: language,
    onLanguageChanged: onLanguageChanged,
    onLanguageInputClicked: onLanguageInputClicked,
    categories: categories,
    onCategoriesChanged: onCategoriesChanged,
    onCategoriesInputClicked: onCategoriesInputClicked,
    storedState: storedState,
    federatedSearchSyncInProgress: federatedSearchSyncInProgress,
    isSavingFederatedSearchSetting: isSavingFederatedSearchSetting
  });
  var enabledIntegrations = [];

  if (isTicketEscalationEnabled) {
    enabledIntegrations.push(TicketCreationIntegrationPanel);
  }

  if (isSelfServiceDashboardEnabled) {
    enabledIntegrations.push(SelfServiceIntegrationPanel);
  }

  if (isFederatedSearchEnabled) {
    enabledIntegrations.push(FederatedSearchIntegrationPanel);
  }

  return (0, _preact.h)("div", {
    className: "integration__tab"
  }, !isInstalled && (0, _preact.h)(_Message.Message, {
    text: "Please install the app first to configure the integrations.",
    fullWidth: true
  }), (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: activePanel,
    panels: enabledIntegrations,
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  }), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal();
    },
    resetChanges: function resetChanges() {
      return _resetChanges();
    }
  }));
};

exports.IntegrationTab = IntegrationTab;

var InstallationTab = function InstallationTab(_ref2) {
  var isInstalled = _ref2.isInstalled,
      onSave = _ref2.onSave,
      onCancel = _ref2.onCancel,
      apiToken = _ref2.apiToken,
      onClickManage = _ref2.onClickManage,
      onApiTokenChangeCallback = _ref2.onApiTokenChangeCallback,
      onApiTokenClickCallback = _ref2.onApiTokenClickCallback,
      onSubdomainChangeCallback = _ref2.onSubdomainChangeCallback,
      onSubdomainClickCallback = _ref2.onSubdomainClickCallback,
      onClickUninstall = _ref2.onClickUninstall,
      subdomain = _ref2.subdomain,
      errorFields = _ref2.errorFields,
      hasUnsavedChanges = _ref2.hasUnsavedChanges,
      showUnsavedChangesModal = _ref2.showUnsavedChangesModal,
      displayUnsavedChangedModal = _ref2.displayUnsavedChangedModal,
      _closeModal2 = _ref2.closeModal,
      _resetChanges2 = _ref2.resetChanges,
      agentEmail = _ref2.agentEmail,
      onAgentEmailClickCallback = _ref2.onAgentEmailClickCallback,
      onAgentEmailChangeCallback = _ref2.onAgentEmailChangeCallback,
      isSavingCredentials = _ref2.isSavingCredentials;
  var FreshdeskInstallationPanel = (0, _InstallationPanel.getInstallationPanel)({
    isInstalled: isInstalled,
    onSave: onSave,
    onCancel: onCancel,
    onApiTokenChangeCallback: onApiTokenChangeCallback,
    onApiTokenClickCallback: onApiTokenClickCallback,
    onSubdomainChangeCallback: onSubdomainChangeCallback,
    onSubdomainClickCallback: onSubdomainClickCallback,
    onClickManage: onClickManage,
    onClickUninstall: onClickUninstall,
    apiToken: apiToken,
    subdomain: subdomain,
    agentEmail: agentEmail,
    onAgentEmailChangeCallback: onAgentEmailChangeCallback,
    onAgentEmailClickCallback: onAgentEmailClickCallback,
    errorFields: errorFields,
    hasUnsavedChanges: hasUnsavedChanges,
    isSavingCredentials: isSavingCredentials
  });
  return (0, _preact.h)("div", {
    className: "installation__tab__wrapper"
  }, (0, _preact.h)("div", {
    className: "installation__tab"
  }, (0, _preact.h)(_AccordionPanel.default, {
    defaultActivePanelIndex: 0,
    panels: [FreshdeskInstallationPanel],
    renderUnsavedChangesModal: function renderUnsavedChangesModal() {
      return displayUnsavedChangedModal();
    }
  })), (0, _preact.h)(_PanelItems.UnsavedChangesModal, {
    showUnsavedChangesModal: showUnsavedChangesModal,
    closeModal: function closeModal() {
      return _closeModal2();
    },
    resetChanges: function resetChanges() {
      return _resetChanges2();
    }
  }));
};

exports.InstallationTab = InstallationTab;